import React from 'react';
import { useLocation } from 'react-router-dom';
import RubriqIthenticateCart from './RubriqIthenticateCart';
var RubriqIthenticateCartWrapper = function RubriqIthenticateCartWrapper() {
  var _location$state;
  var location = useLocation();
  var fileIdentity = (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.fileIdentity;
  return /*#__PURE__*/React.createElement(RubriqIthenticateCart, {
    fileIdentity: fileIdentity
  });
};
export default RubriqIthenticateCartWrapper;